import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import AiInspectionPlushieInspectionDraft from "./ai-inspection-plushie-inspection-draft.model";

export default class AiInspectionPlushieInspectionDraftFactory
  implements ObjectBuilderInterface<AiInspectionPlushieInspectionDraft> {
  public buildFromJSON(data: {
    [key: string]: any;
  }): AiInspectionPlushieInspectionDraft {
    const value = new AiInspectionPlushieInspectionDraft(
      data.id,
      data.plushieId,
      +data.qaGroupNumber,
      data.comment
    );

    (value as any).fCreatedAt = new Date(data.createdAt);
    value.isNew = false;

    return value;
  }
}
